<template>
  <AppIcon :icon color="primary" size="x-small" />
</template>

<script setup lang="ts">
defineProps<{
  icon: string;
}>();
</script>